// src/components/RemoteFile.tsx
import React, { JSX, useEffect } from 'react';
import { s3Url } from './s3';

// +++ new prop
type Props = {
  keyPath:   string;
  alt?:      string;
  className?: string;
  onLog?:    (msg: string) => void;
};

const RemoteFile: React.FC<Props> = ({ keyPath, alt = '', className, onLog }) => {
  const url  = s3Url(keyPath);
  const ext  = keyPath.split('.').pop()?.toLowerCase() ?? '';
  const isSupported = ext in {
    png: true,
    jpg: true,
    jpeg: true,
    gif: true,
    webp: true,
    svg: true,
    html: true,
    htm: true,
  };
  useEffect(() => { onLog?.('Gamic is initialising…'); },[] );
  useEffect(() => { onLog?.(`Loading ${ext.toUpperCase()} file…`); },[]);
  useEffect(() => {
    if (!keyPath) return;
    if (!isSupported) {
      onLog?.(`❌ Unsupported file type: ${ext.toUpperCase() || 'UNKNOWN'}`);
    }
  }, [ext, isSupported, keyPath, onLog]);

  const markLoaded  = () => onLog?.('Rendered successfully.');
  const markFailed  = () => onLog?.('❌  Preview failed to load.');

  const img = (u: string) =>
    <img src={u} alt={alt} className={className} onLoad={markLoaded} onError={markFailed} />;

  const frame = (u: string, title: string) =>
    <iframe
      src={u}
      title={title}
      className={className}
      onLoad={markLoaded}
      onError={markFailed}
      style={{ borderRadius: "10px" }} 
    />;

  const renderers = {
    png : img, jpg: img, jpeg: img, gif: img, webp: img, svg: img,
    html: (u: string) => frame(u, 'HTML preview'),
    htm : (u: string) => frame(u, 'HTML preview'),
  } as Record<string, (u: string) => JSX.Element>;

  // Check if the file extension is supported
  if (ext in renderers) {
    return renderers[ext](url);
  } else {
    return <p className={className}>Unsupported file type</p>; // Optional, can be removed
  }
};

export default RemoteFile;
